import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { ReportActionField } from '../interfaces/reportActions';

export type ReportActionState = {
  availableActions: ReportActionField[]
  currencyChoices: string[];
};

const initialState: ReportActionState = {
  availableActions: [],
  currencyChoices: [],
};

const reportActionSlice = createSlice({
  name: 'reportData',
  initialState,
  reducers: {
    setAvailableActions: (state, action: PayloadAction<ReportActionField[]>) => {
      state.availableActions = action.payload;
    },
    setCurrencyChoices: (state, action: PayloadAction<string[]>) => {
      state.currencyChoices = action.payload;
    },
  },
});

export const {
  setAvailableActions,
  setCurrencyChoices,
} = reportActionSlice.actions;

export default reportActionSlice.reducer;
